import { jsx as l } from "react/jsx-runtime";
const r = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M53.35 48h-13.3V33H51.1l2.25 15 3.89-1.04L52 12H15.54c-2.01 0-3.71 1.45-4.01 3.41l-4.86 32C6.3 49.82 8.2 52 10.68 52h43.75l-1.08-4ZM40.06 16h8.5l2.24 15H40.06V16Zm-24.52 0h8.52v15H13.21l2.28-14.98c0-.01.02-.02.05-.02Zm-4.91 31.99L12.91 33h11.15v15H10.68c-.02 0-.04 0-.05-.01Zm27.43.01h-12V33h12v15Zm0-17h-12V16h12v15Z"
      }
    )
  }
);
export {
  r as SolarPanel
};
